import styled from 'styled-components'

import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

const StyledRequiredIndicator = styled.span`
  color: ${(props: any) => themeUtilities.getRgbaColor(props.theme, 'colors.attention.normal')};
  padding: 0 4px;
  flex: 0 0 15px;

  &::before {
    content: '${(props: any) => (props.isRequired ? '*' : '')}';
  }
`

export default StyledRequiredIndicator
